module.exports = __webpack_public_path__ + "media/src/img/compose_music-156ead8dfc2d4ffa5f426ba8d05e610d46037428fabbd2941cd56f20c8141f95.svg";